import useOutsideClick from "../../hooks/useOutsideClick";

/**
 * Backdrop + click-outside-to-close shell. Both PaymentModal and ShareModal
 * previously carried their own copy of the listener wiring.
 */
const Modal = ({ open, onClose, title, children, className = "" }) => {
  const ref = useOutsideClick(open, onClose);

  if (!open) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={title}
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4 backdrop-blur-sm"
    >
      <div
        ref={ref}
        className={`relative w-full max-w-lg overflow-hidden rounded-lg bg-[#191919] text-white shadow-xl ${className}`}
      >
        <button
          type="button"
          onClick={onClose}
          aria-label="بستن"
          className="absolute left-3 top-3 z-10 text-gray-400 transition hover:text-white"
        >
          ✕
        </button>
        {title && (
          <div className="border-b border-gray-700 p-4">
            <h2 className="text-lg font-semibold">{title}</h2>
          </div>
        )}
        {children}
      </div>
    </div>
  );
};

export default Modal;
